import React, { useState } from 'react';
import PropTypes from 'prop-types';

import OnExitIcon from '../../../icons/OnExitIcon';
import IconError from '../../IconError';

import app from '../../../app.module.css';
import local from './messageBanners.module.css';

const _TIME = 1000;

const ScreenError = ({
    error,
    name = 'businessLogicError',
    clearError,
    customClass = '',
    allowDismiss = true
}) => {
    const [isFadeout, setIsFadeout] = useState(false);

    const onClearError = () => {
        setIsFadeout(true);
        setTimeout(() => clearError(name), _TIME);
    };

    return (
        <div
            className={`${local.screenError} ${local[customClass]} ${app.fadein} ${isFadeout ? app.fadeout : ''}`}>
            <span>
                <IconError text={error} />
            </span>
            {allowDismiss && (
                <span className={local.clearErrorWrapper}>
                    <OnExitIcon title="Clear" customClass="redIcon" onClick={onClearError} />
                </span>
            )}
        </div>
    );
};

ScreenError.propTypes = {
    error: PropTypes.object,
    name: PropTypes.string,
    clearError: PropTypes.func,
    customClass: PropTypes.string,
    allowDismiss: PropTypes.bool
};

export default ScreenError;
